import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'contabilidad/cuentas-contables';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getCuentasContables = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Jornada
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJornadaDetalleHorario = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Jornada
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContable = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Jornada
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContable = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Jornada
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCuentaContable = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
